import { useEffect, useState } from 'react';

import clsx from 'clsx';
import dayjs, { Dayjs } from 'dayjs';

import { useAppTranslation } from '@/app/i18n/client';

export function RevalidationMessage({
  date,
  timeout = 5000,
  size = 'md',
  className,
}: {
  date?: Dayjs;
  timeout?: number;
  size?: 'sm' | 'md';
  className?: string;
}) {
  const {
    t,
    i18n: { language },
  } = useAppTranslation(['common']);
  const [diff, setDiff] = useState(
    date?.add(timeout, 'milliseconds').diff(dayjs(), 'seconds') ?? 0
  );
  const rtf = new Intl.RelativeTimeFormat(language, {
    numeric: 'always',
    localeMatcher: 'best fit',
    style: 'long',
  });

  useEffect(() => {
    setDiff(date?.add(timeout, 'milliseconds').diff(dayjs(), 'seconds') ?? 0);
    const interval = setInterval(() => {
      setDiff(date?.add(timeout, 'milliseconds').diff(dayjs(), 'seconds') ?? 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [date, timeout]);

  const hide = !date || diff <= 0;

  return (
    <p
      className={clsx(
        className,
        '-mt-2 text-right transition-opacity dark:text-white',
        hide ? 'opacity-0' : '',
        size === 'sm' && 'text-sm font-medium'
      )}
    >
      {t('common:revalidation')}: {rtf.format(diff, 'seconds')}
    </p>
  );
}
